"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useProductListStore = void 0;
const pinia_1 = require("pinia");
const fetch_1 = __importDefault(require("../../../common/utils/fetch"));
const tyre_search_1 = require("../../../components/ProductSearch/tyre-search");
const productListHelper_1 = require("./productListHelper");
exports.useProductListStore = (0, pinia_1.defineStore)('productListStore', {
    state: () => ({
        loading: false,
        list: []
    }),
    getters: {
        productsWithDiscountTheme: (state) => {
            return (0, productListHelper_1.attachDiscountTheme)(state.list);
        }
    },
    actions: {
        async getProducts(router, filterParams) {
            this.loading = true;
            filterParams.itemsPerPage = tyre_search_1.MAX_HITS;
            if (router.currentRoute.value.name !== 'shop_sku_search' &&
                router.currentRoute.value.name !== 'product_return_guarantee' &&
                router.currentRoute.value.name !== 'product_return_customer') {
                filterParams.active = 1;
            }
            try {
                const response = await (0, fetch_1.default)(router.resolve({ name: 'shop_products', query: filterParams }).href);
                const list = [];
                if (Array.isArray(response['hydra:member'])) {
                    response['hydra:member'].forEach(element => {
                        if (element['@type'] !== 'Product') {
                            return;
                        }
                        list.push(element);
                    });
                }
                this.list = list;
                this.loading = false;
                return list;
            }
            catch (error) {
                console.error('Error fetching products:', error);
                this.loading = false;
                throw error;
            }
        },
        async showStockDetails(router, id) {
            if (this.hasStockDetailsLoaded(id)) {
                this.showStockDetailsBox(id);
                return Promise.resolve();
            }
            this.setStockDetailsLoading(id);
            try {
                const response = await (0, fetch_1.default)(router.resolve({ name: 'shop_products_stock_details', params: { id: id } }).href);
                let stockDetails = response;
                this.addStockDetails(id, stockDetails);
                return response;
            }
            catch (error) {
                console.error('Error fetching stock details:', error);
                throw error;
            }
        },
        hideStockDetails(id) {
            this.hideStockDetailsBox(id);
            return Promise.resolve(true);
        },
        setStockDetailsLoading(id) {
            this.list.forEach((item) => {
                if (item.id === id) {
                    item.stocks.stockDetailsStatus = 'details-loading';
                }
            });
        },
        addStockDetails(id, stockDetails) {
            this.list.forEach((item) => {
                if (item.id === id) {
                    if (stockDetails.length) {
                        item.stocks.stockDetails = stockDetails;
                    }
                    item.stocks.stockDetailsStatus = '';
                }
            });
        },
        showStockDetailsBox(id) {
            this.list.forEach((item) => {
                if (item.id === id) {
                    item.stocks.stockDetailsStatus = '';
                }
            });
        },
        hideStockDetailsBox(id) {
            this.list.forEach((item) => {
                if (item.id === id) {
                    item.stocks.stockDetailsStatus = 'hidden';
                }
            });
        },
        hasStockDetailsLoaded(id) {
            let found = false;
            this.list.forEach((item) => {
                var _a, _b;
                if (item.id === id) {
                    if ((_b = (_a = item.stocks) === null || _a === void 0 ? void 0 : _a.stockDetails) === null || _b === void 0 ? void 0 : _b.length) {
                        found = true;
                    }
                }
            });
            return found;
        },
        reset() {
            this.loading = false;
            this.list = [];
        }
    }
});
